import { render } from "./ProdName02.vue?vue&type=template&id=5f464788&scoped=true"
import script from "./ProdName02.vue?vue&type=script&lang=js"
export * from "./ProdName02.vue?vue&type=script&lang=js"

import "./ProdName02.vue?vue&type=style&index=0&id=5f464788&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f464788"]])

export default __exports__